import React, { useCallback } from 'react';
import classNames from 'classnames';

import { useUserInfo } from 'lib/user';
import { useUnbindSocialOAuth } from 'api/user_profile/user_profile_social_unbind';
import { useGetSocialOAuth } from 'api/user_profile/user_profile_social_oauth_url';
import { useAppSelector } from 'store/hooks';
import {
  CheckContainedFill,
  Circle,
  DiscordFillBrand,
  XCircleContained,
} from 'lib/lucky-x-icons-2';

interface IConnectDiscordLabelProps {}

const ConnectDiscordLabel: React.FC<IConnectDiscordLabelProps> = ({}) => {
  const { isLogin } = useUserInfo();
  const { discordUnbind } = useUnbindSocialOAuth();
  const { discordOauth } = useGetSocialOAuth();
  const {
    raffleInfo: { my_entry },
    raffleRegisterResult: { validation },
    discordUsername,
  } = useAppSelector((state) => state.raffleDetails);

  const render = useCallback(() => {
    return (
      <div>
        <div className="flex items-center justify-between text-base font-normal text-neutral-100">
          <div className="flex items-center gap-2">
            <DiscordFillBrand size={24} color="#5865F2" />
            <div>Discord</div>
          </div>
          <div>
            {isLogin && discordUsername ? (
              <div className="flex items-center justify-end gap-2 ">
                <div className="max-w-[140px] truncate font-semibold">
                  {discordUsername}
                </div>
                {!my_entry && !validation && (
                  <XCircleContained
                    size={24}
                    className="shrink-0 cursor-pointer "
                    onClick={
                      isLogin
                        ? () => {
                            discordUnbind();
                          }
                        : () => {}
                    }
                  />
                )}
              </div>
            ) : (
              <div
                className={classNames(
                  'flex h-8 w-[100px] items-center justify-center gap-1 rounded-full bg-[#5865F2]',
                  {
                    'cursor-pointer': isLogin,
                    'cursor-not-allowed': !isLogin,
                  }
                )}
                onClick={() => {
                  if (!isLogin) {
                    return;
                  }
                  discordOauth();
                }}
              >
                <DiscordFillBrand size={20} color="#fff" />
                <div className="text-sm font-normal text-white">Connect</div>
              </div>
            )}
          </div>
        </div>

        <div className="mt-2 flex items-center gap-3 rounded-2xl border-[1px] border-neutral-600 p-4">
          {!!discordUsername ? (
            <CheckContainedFill size={24} color="#98FF59" />
          ) : (
            <Circle size={24} className="text-neutral-400" />
          )}
          <div className="w-full whitespace-pre-line text-base  font-normal text-neutral-100 md:w-auto">
            Connect Discord
          </div>
        </div>
      </div>
    );
  }, [
    discordOauth,
    discordUnbind,
    discordUsername,
    isLogin,
    my_entry,
    validation,
  ]);

  return <div>{render()}</div>;
};

export default ConnectDiscordLabel;
